import React, { ReactChild, ReactNode, useState, useContext } from 'react';
import { IComponentButtonGroup, IOneButton } from '../../component';
import Cube from './Cube';
import { ThemeContext } from '../../store/ThemeProvider';
import { IconType } from '../../global.d';
import { formatImage } from '../../utils/util';
import './AllForButtonGroup.scss';
import ComponentLink from '../ComponentLink';
import BottomModal from './BottomModal';
import Guests from './Guests';
import ActFlow from './ActFlow';
import ActInfo from './ActInfo';
import intl from 'react-intl-universal';

export const getNameByType = function(type: string) {
  switch (type) {
    case 'sponsor':
      return intl.get('organizer');
    case 'act-info':
      return intl.get('Introduction');
    case 'act-flow':
      return intl.get('agenda');
    case 'guest-intro':
      return intl.get('speaker-guest');
    default:
      return '';
  }
};

const AllForButtonGroup = function(props: IComponentButtonGroup) {
  const { buttons, actflow, actinfo, guests, sponsor } = props;
  const [showBottom, setShowBottom] = useState(false);
  const [title, setTitle] = useState('');
  const [child, setChild] = useState<ReactNode>('');

  const themeContext = useContext(ThemeContext);
  const { h2Color } = themeContext;

  const onClick = function(btn: IOneButton) {
    console.log('clicked', btn);
    const { type, link, desc } = btn;
    if (type === 'modal') {
      setTitle(String(desc));
      setShowBottom(true);
      setChild(String(btn.content));
    } else if (type === 'custom') {
      ComponentLink.to(link);
    } else {
      // 默认的一些玩意咯
      setTitle(getNameByType(type));
      setShowBottom(true);
      let content = '' as ReactChild;
      switch (type) {
        case 'act-flow':
          content =
            actflow.edittype == 'template' ? (
              <ActFlow edittype={actflow.edittype} content={actflow.content} />
            ) : (
              actflow.content
            );
          break;
        case 'act-info':
          content =
            actinfo.edittype == 'template' ? (
              <ActInfo edittype={actinfo.edittype} content={actinfo.content} />
            ) : (
              actinfo.content
            );
          break;
        case 'sponsor':
          content = sponsor.edittype == 'template' ? <div /> : sponsor.content;
          break;
        case 'guest-intro':
          content = (
            <Guests content={guests.content} edittype={guests.edittype} />
          );
          break;
        default:
          break;
      }
      setChild(content);
    }
  };

  return (
    <div className="all-for-button-group" style={{ color: h2Color }}>
      {(buttons || []).map((btn, index) => {
        const { type, image, desc } = btn;
        if (type !== 'custom' && type !== 'modal') {
          const name = getNameByType(type);
          return (
            <Cube
              key={index}
              type={IconType.span}
              className={`icon icon-cube-${type}`}
              text={name}
              event={type}
              onClick={() => onClick(btn)}
            />
          );
        } else {
          return (
            <Cube
              key={index}
              type={IconType.img}
              icon={formatImage(image || '')}
              className={''}
              text={desc || ''}
              event={type}
              onClick={() => onClick(btn)}
            />
          );
        }
      })}
      <BottomModal
        title={title}
        show={showBottom}
        onHide={() => setShowBottom(false)}
        child={child}
      />
    </div>
  );
};

export default AllForButtonGroup;
